import contracts from '@/views/contracts'
import contractsAttendanceTasks from '@/views/contracts/attendance-tasks'
import modalsEditTasks from '@/views/contracts/modals/edit-tasks.vue'
import modalsNew from '@/views/contracts/modals/new-flowr-subscription.vue'
import modalsPreviewDocument from '@/views/contracts/modals/preview-document.vue'
import modalsSelect from '@/views/contracts/modals/select-subscribs.vue'
import modalsSignersSettings from '@/views/contracts/modals/signers-settings.vue'
import modalsStatus from '@/views/contracts/modals/status-subscribs.vue'

import { storage } from '@/services/storage'

const routes = [
	{
		path: '/contrato/general/:dealId?',
		name: 'contrato',
		component: contracts,
		meta: {
			title: (storage.get('client_name') || 'Facilita') + ' - Contrato',
			protect: true,
			iframe: true,
		},
	},
	{
		path: '/contrato/new/:files?/:dealId?',
		name: 'contrato.modals.new',
		component: modalsNew,
		props: true,
		meta: {
			title: (storage.get('client_name') || 'Facilita') + ' - Novo Contrato',
			protect: true,
		},
	},
	{
		path: '/contrato/select/:files?/:flowName?/:flowType?/:dealId?',
		name: 'contrato.modals.select',
		component: modalsSelect,
		props: true,
		meta: {
			title: (storage.get('client_name') || 'Facilita') + ' - Selecionar Assinantes',
			protect: true,
		},
	},
	{
		path: '/contrato/status/:data?',
		name: 'contrato.modals.status',
		component: modalsStatus,
		props: true,
		meta: {
			title: (storage.get('client_name') || 'Facilita') + ' - Status do Contrato',
			protect: true,
		},
	},
	{
		path: '/contrato/signers-settings/:productId?',
		name: 'contrato.modals.signers',
		component: modalsSignersSettings,
		props: true,
		meta: {
			title: (storage.get('client_name') || 'Facilita') + ' - Configuração de Signatários',
			protect: true,
		},
	},
	{
		path: '/contrato/preview-document/:url?',
		name: 'contrato.modals.previewdocument',
		component: modalsPreviewDocument,
		props: true,
		meta: {
			title: (storage.get('client_name') || 'Facilita') + ' - Pré-visualizar documento',
			protect: true,
		},
	},
	{
		path: '/contrato/attendance-tasks/:dealId',
		name: 'contrato.attendanceTasks',
		component: contractsAttendanceTasks,
		meta: {
			title: (storage.get('client_name') || 'Facilita') + ' - Contrato Atendimentos e Tarefas',
			protect: true,
			iframe: true
		},
	},
	{
		path: '/contrato/edit-tasks/:dealId?',
		name: 'contrato.modals.editTasks',
		component: modalsEditTasks,
		props: true,
		meta: {
			title: (storage.get('client_name') || 'Facilita') + ' - Pré-visualizar documento',
			protect: true,
		},
	}
]

export { routes }

